import React from 'react';
import { Link, Text } from '@chakra-ui/react';

const UserSyncBannerMessage = ({ supportUrl }) => {
  return (
    <Text className="notification-bar-string-message">
      Action required: Please complete your user sync to fully onboard your
      tenant for access to The Exchange. Having trouble?
      {' '}
      <Link href={supportUrl} isExternal color="inherit" textDecoration="underline">
        Contact Tech Support
      </Link>
    </Text>
  );
};

export default UserSyncBannerMessage;
